module.exports = __webpack_public_path__ + "static/media/postcardRetro6.8bf1c718.jpg";